import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchRoadTypes = createAsyncThunk('roadTypes/fetch', async (params, { rejectWithValue }) => {
  try { const res = await service.getRoadTypes(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})
export const fetchRoadType = createAsyncThunk('roadTypes/fetchOne', async (id, { rejectWithValue }) => { try { return await service.getRoadType(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const addRoadType = createAsyncThunk('roadTypes/add', async (payload, { rejectWithValue }) => { try { return await service.addRoadType(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const saveRoadType = createAsyncThunk('roadTypes/save', async (payload, { rejectWithValue }) => { try { return await service.updateRoadType(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const removeRoadType = createAsyncThunk('roadTypes/remove', async (id, { rejectWithValue }) => { try { await service.deleteRoadType(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) } })

const slice = createSlice({
  name: 'roadTypes',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setRoadTypeParams(s, a) { s.params = a.payload } },
  extraReducers: b => {
    b.addCase(fetchRoadTypes.pending, s => { s.loading = true })
     .addCase(fetchRoadTypes.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchRoadTypes.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchRoadType.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addRoadType.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveRoadType.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeRoadType.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setRoadTypeParams } = slice.actions
export default slice.reducer
